interface LeadFiltersProps {
  activeType: 'USER' | 'PROFESSIONAL' | undefined;
  onTypeChange: (type: 'USER' | 'PROFESSIONAL' | undefined) => void;
  search: string;
  onSearchChange: (search: string) => void;
}

const tabs = [
  { label: 'Tutti', value: undefined },
  { label: 'Utenti', value: 'USER' as const },
  { label: 'Professionisti', value: 'PROFESSIONAL' as const },
];

export function LeadFilters({ activeType, onTypeChange, search, onSearchChange }: LeadFiltersProps) {
  return (
    <div className="flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between">
      <div className="flex gap-2">
        {tabs.map((tab) => (
          <button
            key={tab.label}
            onClick={() => onTypeChange(tab.value)}
            aria-pressed={activeType === tab.value}
            className={`px-4 py-1.5 text-sm font-medium rounded-full transition-all ${
              activeType === tab.value
                ? 'bg-brand-teal text-white shadow-sm'
                : 'bg-neutral-100 text-neutral-600 hover:bg-neutral-200'
            }`}
          >
            {tab.label}
          </button>
        ))}
      </div>

      <div className="relative">
        <svg
          className="absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-neutral-500"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
        </svg>
        <input
          type="text"
          placeholder="Cerca per nome o email..."
          value={search}
          onChange={(e) => onSearchChange(e.target.value)}
          className="w-full rounded-full border border-neutral-200 bg-neutral-50 py-2 pl-10 pr-4 text-sm focus:border-brand-teal focus:bg-white focus:outline-none focus:ring-1 focus:ring-brand-teal transition-colors sm:w-64"
        />
      </div>
    </div>
  );
}
